import { type ReactNode } from "react";
import { Shield, Users, Crown } from "lucide-react";

type Role = "employer" | "candidate" | "admin";

const roleConfig: Record<
  Role,
  { label: string; badgeClass: string; icon: ReactNode }
> = {
  employer: {
    label: "Employer Workspace",
    badgeClass: "role-badge role-badge-employer",
    icon: <Shield className="h-3 w-3" aria-hidden />,
  },
  candidate: {
    label: "Candidate Portal",
    badgeClass: "role-badge role-badge-candidate",
    icon: <Users className="h-3 w-3" aria-hidden />,
  },
  admin: {
    label: "Admin Control Room",
    badgeClass: "role-badge role-badge-admin",
    icon: <Crown className="h-3 w-3" aria-hidden />,
  },
};

export interface RoleBadgeProps {
  role: Role;
  label?: string;
}

export function RoleBadge({ role, label }: RoleBadgeProps) {
  const config = roleConfig[role];

  return (
    <span className={config.badgeClass}>
      {config.icon}
      {label ?? config.label}
    </span>
  );
}
